import { createApp } from 'vue'

import App from './App.vue'

import router from './router'

import 'font-awesome-animation/css/font-awesome-animation.min.css'

import '@/assets/main.css'

import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import TippyPlugin from 'vue-tippy'
import 'tippy.js/dist/tippy.css'

import VisibilityDirective from './directives/visibility'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  fas,
  faSpinner,
  faRectangleXmark,
  faXmark,
  faCircleArrowLeft,
  faCircleArrowRight,
  faCartPlus,
  faMagnifyingGlassPlus
} from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas)
library.add(faSpinner)
library.add(faRectangleXmark)
library.add(faXmark)
library.add(faCircleArrowLeft)
library.add(faCircleArrowRight)
library.add(faCartPlus)
library.add(faMagnifyingGlassPlus)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

document.addEventListener('DOMContentLoaded', () => {
  createApp(App)
  .use(router)
  .use(pinia)
  .use(TippyPlugin)
  .directive('visibility', VisibilityDirective)
  .component('font-awesome-icon', FontAwesomeIcon)
  .mount('#app')
})

